var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    [
      _c("template", { slot: "header-left-dropdown" }, [_c("div")]),
      _c(
        "template",
        { slot: "content-center" },
        [
          _vm.isFetchingData
            ? _c("TableLoading")
            : [
                _vm.renderComponent && !_vm.isFetchingData
                  ? _c("IntegrationItems", {
                      attrs: { list: _vm.IntegrationProductList },
                      on: {
                        openActionPopup: _vm.openPopup,
                        closeActionPopup: _vm.closeActionPopup,
                        activateModal: _vm.activateModal,
                        closeModal: _vm.closeModal,
                      },
                    })
                  : _vm._e(),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }